export const getCourtsListSelector = (state) => state.courtsList.courtsList;
